import { Icon, type IconProps } from './Icon';

/** Fechar — folha, diálogo, chip removível. Substitui o `✕`. */
export function CloseIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </Icon>
  );
}
